<div class="flex gap-2 items-center">
	<ui-button
		icon="plus"
		(click)="toggleAddClient()"
		[label]="addButtonText"
		[testHook]="testHooks.AddTextButton"
	/>
	<app-client-search
		*ngIf="showAddClient"
		(onDelayFinished)="onDelayFinished()"
		[placeholder]="placeholder"
		(clientSelected)="onClientSelected($event)"
		[searchType]="SearchType.CardsAndPeople"
		(add)="addClient($event)"
		class="flex min-w-96 flex-1"
		[createButtonLabel]="createButtonLabel"
		[contactTypeLabel]="contactTypeLabel"
		[testHook]="testHooks.ClientSearchInput"
	></app-client-search>
</div>
